import React from 'react';
import CrmConstituentIdsPage from '../components/CrmConstituentIdsPage';

const CrmConstituentIdsApp = (props) => (
  <CrmConstituentIdsPage {...props} />
);

export default CrmConstituentIdsApp;
